import { createContext } from "react";

export const FormLabelsContext = createContext({
  required: "*",
  selectPlaceholder: "",
});
